import type { SortOrder } from "./types";

export type SortColumnConfig = {
  key: string;
  defaultOrder?: SortOrder;
  isDefault?: boolean;
};

export type SortProps = {
  columns: SortColumnConfig[];
};

// Sort is a config-only component - its props are read by Root
export function Sort(_props: SortProps) {
  return null;
}
